<h1 mat-dialog-title>{{title}}</h1>
<div mat-dialog-content>
  <form [formGroup]="formBid" autocomplete="off"
    style="min-height: 500px; width: 100%;">

    <mat-form-field appearance="outline" style="width: 100%; margin-bottom: 3px !important;">
      <mat-label>Estimated cost </mat-label>
      <input matInput
        (change)="onEstimatedCostChangeEvent($event)"
        type="number"
        min="1.00"
        required
        id="estimatedCost"
        name="estimatedCost"
        formControlName="estimatedCost">
      <span matPrefix>
        <mat-icon style="font-size: 15px;">attach_money</mat-icon>
      </span>
      <mat-error *ngIf="formBid.get('estimatedCost').hasError('required')">
        Estimated cost is required.
      </mat-error>

      <mat-error *ngIf="formBid.get('estimatedCost').hasError('min')">
        Estimated cost must be greater than 1.00.
      </mat-error>
    </mat-form-field>
    <div *ngIf='data.firstOrSecond == "1stBid" && data.estimatedCost > data.estimatemax && data.multipleBidsRequired && data.multipleBidsRequired === true && (data.isSelected == true || bidSelected == true)'
      style="margin-bottom: 20px;color: gray;">
     Estimated cost is greater than {{ data.estimatemax | currency:'USD':'symbol':'1.0-0' }}.<br>A second estimate is required.
    </div>
    <div style="width: 100%;">
      <mat-form-field
        appearance="outline"
        style="width: 100%; margin-bottom: 3px !important;">
          <mat-label>Contractor</mat-label>
          <input matInput required autocomplete="off" readonly
            placeholder="File name"
            id="AttachmentName"
            name="AttachmentName"
            formControlName="AttachmentName">
      </mat-form-field>
      <button mat-flat-button color="accent"
        [hidden]="data.firstOrSecond !== '2ndBidEdit'"
        style="float: right; margin-top: 15px;"
        (click)="onClickChangeContractor()">
        CHANGE
      </button>
     </div>
    <div style="width: 100%;">
      <input #ebbFileInput
        style="display: none;"
        type="file"  title="file"
        onclick="this.value=null"
        (change)="ebbFileInputChange($event)"/>
    </div>
    <div style="margin-top: -10px !important;" ngClass.gt-sm="'buttonAlignContainer'">
      <button mat-flat-button color="accent"
        style="margin-right:9px; min-width:135px;"
        ngStyle.lt-md="{'margin-bottom': '9px'}"
        (click)="ebbFileInput.click()">
        {{fileUploadLabel}}
      </button>
      <button mat-flat-button color="accent"
        style="min-width:135px;"
        *ngIf="showRotateImage"
        (click)="rotateImageOrientation()">
        <mat-icon>rotate_right</mat-icon>
        ROTATE {{rotateDegree}}&deg;
      </button>
    </div>

    <div  style="width: 100%; display: block; float: left;">
      <p *ngIf="!fileError">{{displayFileName}}</p>
      <p *ngIf="fileError" class="mat-error"><mat-icon>warning</mat-icon> {{displayFileName}}</p>
    </div>
   
    <div style="width: 100%; display: block; float: left; margin-top: 9px;">
      <div *ngIf="!displayFileUrl" style="color: #727272;">
        <p>Only the following file types can be uploaded:</p>
        <ul>
          <li *ngIf='!data.isImage'>Adobe PDF</li>
          <li *ngIf='!data.isImage'>Microsoft Word DOCX</li>
          <li>Image JPG</li>
          <li>Image PNG</li>
        </ul>
        <p>The maximum file size is {{fileMaxSize}}MB.</p>
      </div>
      <div *ngIf="displayFileUrl" style="align-content: center;">
        <div *ngIf="!data.isImage">
          <img [src]="displayFileUrl" style="height: 150px;" alt="uploaded file" />
        </div>
        <div style="align-content: center;"
          *ngIf="displayLink === 'true'">
           <a style="color: #29637C; font-size: 16px; font-weight: 400;"
              href="javascript:void(0)" (click)="onViewFileEvent(fileId,payloadName)">
              {{payloadName}}
          </a>
        </div>
      </div>
      <div>
        <div style="margin-top: 15px;">
          <mat-checkbox
            id="selectThisBid"
            name="selectThisBid"
            formControlName="selectThisBid"
            [checked]="bidSelected===true"
            (change)="onClickSelect()">
            Hire Contractor
          </mat-checkbox>
        </div>
      </div>
      <div *ngIf="higherBidSelected === true" >
        <mat-form-field appearance="outline" style="width: 100%; margin-bottom: 3px !important;">
          <mat-label>Reason for selecting higher estimate </mat-label>
          <input matInput
            (change)="onReasonChangeEvent($event)"
            required
            id="reasonForHigherBid"
            name="reasonForHigherBid"
            formControlName="reasonForHigherBid" />
          <mat-error *ngIf="formBid.get('reasonForHigherBid').hasError('required')">
            Reason is required.
          </mat-error>
        </mat-form-field>
      </div>
    </div>

  </form>
</div>

<div mat-dialog-actions style="margin-top: 9px !important; float: right !important;">
  <button mat-button
    (click)="onClickCancel()">
    CANCEL
  </button>
  <button mat-flat-button
    [mat-dialog-close]="data"
    color="primary"
    [disabled]="disableSubmitBid == true">
    SAVE
  </button>
</div>
